module.exports = __webpack_public_path__ + "img/9788957981405.6b5a37fc.jpg";